import React from 'react'

export default function Loading() {
  return (
    <div className=' w-2/5 h-[40px] bg-text rounded flex items-center justify-center max-md:w-[50%]'>
        <div className='loader'></div>
    </div>
    
  )
}
